module.exports = __webpack_public_path__ + "media/images/mastercard-9e2d2ecdadac4c0ddcc6622aa940d9d5.png";